export type FolioType = 'physical' | 'dmat'

export type IssuerKind = 'listing' | 'rights' | 'firstCall' | 'openExit'

export type CompanyDocument = {
  url: string
  label: string
}

export type CompanyIssueInfo = {
  isin: string
  companyName: string
  openingDate: string
  closingDate: string
  documents: CompanyDocument[]
}

export type IssuerOption = {
  value: string
  label: string
}

export type ServiceFormRequest = {
  company: string
  name?: string
  folioType: FolioType
  dpId?: string
  clientId?: string
  folioNo?: string
  email?: string
  phone?: string
  turnstileToken: string
}

export type PublicActionResponse = {
  success: boolean
  message: string
  loginAttemptId?: string | null
  sessionToken?: string | null
  SessionToken?: string | null
}

export function toServiceFormPayload(request: ServiceFormRequest) {
  return {
    company: request.company,
    name: request.name ?? '',
    folioType: request.folioType,
    dpId: request.dpId ?? '',
    clientId: request.clientId ?? '',
    folioNo: request.folioNo ?? '',
    email: request.email ?? '',
    phone: request.phone ?? '',
    turnstileToken: request.turnstileToken,
  }
}
